import React, { useEffect, useRef, useState } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'

const DebugLogDialog = ({ logs, title = 'Debug' }) => {
  const [minimized, setMinimized] = useState(false)
  const logsContainerRef = useRef(null)

  useEffect(() => {
    if (logsContainerRef.current && !minimized) {
      logsContainerRef.current.scrollTop = logsContainerRef.current.scrollHeight
    }
  }, [logs, minimized])

  const containerStyle = {
    position: 'fixed',
    bottom: '10px',
    left: '10px',
    right: '10px',
    height: minimized ? '40px' : '35vh',
    backgroundColor: 'rgba(0, 0, 0, 0.85)',
    color: '#00ff00',
    fontFamily: 'monospace',
    fontSize: '10px',
    borderRadius: '8px',
    zIndex: 99999,
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid rgba(0, 255, 0, 0.3)',
  }

  const headerStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '6px 10px',
    backgroundColor: 'rgba(0, 0, 0, 0.95)',
    borderBottom: '1px solid rgba(0, 255, 0, 0.3)',
    cursor: 'pointer',
    flexShrink: 0,
  }

  const logsContainerStyle = {
    overflowY: 'scroll',
    WebkitOverflowScrolling: 'touch',
    padding: '6px 10px',
    flex: 1,
    minHeight: 0,
  }

  const logLineStyle = {
    margin: '2px 0',
    wordBreak: 'break-all',
    lineHeight: '1.4',
  }

  return ReactDOM.createPortal(
    <div style={containerStyle}>
      <div style={headerStyle} onClick={() => setMinimized(!minimized)}>
        <span style={{ fontWeight: 'bold', color: '#ffffff' }}>
          {title} ({logs.length})
        </span>
        <span>{minimized ? '▲' : '▼'}</span>
      </div>
      {!minimized && (
        <div ref={logsContainerRef} style={logsContainerStyle}>
          {logs.map((log, index) => (
            <div key={index} style={logLineStyle}>
              {log}
            </div>
          ))}
        </div>
      )}
    </div>,
    document.body,
  )
}

DebugLogDialog.propTypes = {
  logs: PropTypes.arrayOf(PropTypes.string).isRequired,
  title: PropTypes.string,
}

export { DebugLogDialog }
